import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Comp({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('smarthomepanel');

    return (
        <div className={`${css.textA1} textA1`}>
            <div className="msg-title">{t('smart_home_panel.six_title')}</div>
            <div
                className="msg-line1"
                dangerouslySetInnerHTML={{
                    __html: t('smart_home_panel.six_subtitle'),
                }}
            ></div>
        </div>
    );
}
